import React from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';

export function WinRate() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();

    return <div className='mt-4 w-80'>
        <label
            htmlFor='WinRate'
            className='block text-sm font-medium text-gray-700'
        >
            Win Rate
        </label>
        <input
            type='number'
            name='Win Rate'
            min='0'
            max='1'
            step='0.1'
            value={forecastingSettings.winRate}
            className='mt-1 block border border-gray-300 bg-white rounded-md shadow-sm text-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500'
            onChange={(e) => updateForecastingSetting({ winRate: Number(e.target.value) })}
        />
    </div>;
}
